
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/free-legal-research-tools",
      function () {
        return require("private-next-pages/resources/free-legal-research-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/free-legal-research-tools"])
      });
    }
  